import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  DocumentResponse,
  DocumentsApiService,
  DocumentsListParams,
} from 'features/document-report/api/documents-api.service';
import qs from 'qs';

import { DocumentQueryKeys } from './query-keys';

const { getAttentionDocument } = DocumentsApiService();

const getUsersQuery = (
  params: any,
  options?: UseQueryOptions<DocumentResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<DocumentResponse>;
  options?: UseQueryOptions<DocumentResponse>;
} => ({
  queryKey: DocumentQueryKeys.list(params), // Ensure this is unique for each set of params
  queryFn: async ({ signal }) =>
    getAttentionDocument(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetAttentionDocumentList = (
  params: DocumentsListParams,
  options?: UseQueryOptions<DocumentResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
      cacheTime: 1000 * 60 * 10, // Keep data in cache for 10 minutes
      refetchOnWindowFocus: false, // Avoid unnecessary refetch on window focus
      ...options,
    }),
  );
};
